import React from 'react'
import { observer } from 'mobx-react'
import { useEnvValue } from '@morningtrain/react-helpers'
import { mathRoundDecimal } from 'app/React/Util/MathRoundDecimal'
import QuantityField from 'app/React/ProductForm/QuantityField'

function AmountCalculator() {
  const [strings] = useEnvValue('strings')
  const [product] = useEnvValue('product')
  const [selectedVariation] = useEnvValue('selectedVariation', null)
  const [amountCalculatorAmount, setAmountCalculatorAmount] = useEnvValue('amountCalculatorAmount', '')
  const perMeter = typeof selectedVariation === 'object' && selectedVariation !== null ? selectedVariation.perMeter : product.perMeter

  const handleOnChange = function (e) {
    let meters = parseFloat(e.target.value)
    if (e.target.value === '') {
      meters = ''
    }

    setAmountCalculatorAmount(meters)
  }

  return (
    <section className='mtt-amount-calculator-wrap'>
      <div className="mtt-amount-calculator">
        <div className="mtt-amount-calculator__inner">
          <div className="mtt-amount-calculator__title-wrap">
            <p className="mtt-amount-calculator__title-after">
              {strings.amountCalculator.recommendedPerMeter}
              <span className="per-meter">{mathRoundDecimal(perMeter, 2)}</span>
              <span> {strings.pcs}.</span>
            </p>
          </div>
          <input
            type="number"
            min="1"
            placeholder={strings.amountCalculator.placeholder}
            className="mtt-amount-calculator__input"
            onChange={handleOnChange}
            value={amountCalculatorAmount}
          />
        </div>
      </div>
      <QuantityField/>
    </section>
  )
}

export default observer(AmountCalculator)